import { observable, action, toJS } from 'mobx';
import { Api } from 'services/Api';
import stores from './index';

// Empty form for the Add Supplier dialog. It has its own slot (newSupplier)
// so it never shares data with the supplier page's record (supplier.object),
// and it is reset after each create.
const blankSupplier = () => ({
  name: '',
  email: '',
  phone: '',
  address: ''
});

class SupplierStore {  

  @observable suppliers = {
    isLoading: false,
    isError: false,
    objects: [],
    meta: {}
  };

  @observable supplierAnalytics = {
    isLoading: false,
    isError: false,
    objects: []
  };

  @observable newSupplier = {
    isLoading: false,
    isError: false,
    object: blankSupplier()
  };

  @observable isSavingSupplier = false;

  @observable supplier = {
    isLoading: false,
    isError: false,
    object: blankSupplier()
  };

  @action
  clearSupplierObject() {
    this.newSupplier.object = blankSupplier();
  }

  @action
  loadSuppliers() {
    this.suppliers.isLoading = true;
    const {
      per_page,
      page,
      order,
      term
    } = stores.viewStore.supplierSearch;

    let promise = Api.post('/suppliers/search', {
      search: {
        term: term,
        per_page: per_page,
        page: page,
        order: { created_at: 'desc' }
      } 
    });
    promise
      .then((response) => {
        this.suppliers.isLoading = false;
        this.suppliers.isError = false;
        this.suppliers.objects = response.data.data;
        this.suppliers.meta = response.data.meta;
      })
      .catch((error) => {
        this.suppliers.isLoading = false;
        this.suppliers.isError = true;
      })
    
  }

  @action
  createSupplier() {
    this.newSupplier.isLoading = true;
    let promise = Api.post(`/suppliers`, { supplier: this.newSupplier.object })

    promise
      .then((response) => {
        this.newSupplier.isLoading = false;
        this.newSupplier.isError = false;
        this.clearSupplierObject();
      })
      .catch((error) => {
        this.newSupplier.isLoading = false;
        this.newSupplier.isError = true;
      })
    
    return promise
  }

  @action
  // Saves a supplier's details from their page. Its own flag, so the page stays
  // on screen; afterwards it shows what was saved (it used to jump to the
  // suppliers list). Failures are passed on for the panel to report.
  updateSupplier(supplier) {
    this.isSavingSupplier = true;
    let promise = Api.put(`/suppliers/${supplier.attributes.id}`, {supplier: toJS(supplier.attributes)})

    promise
      .then((response) => {
        this.isSavingSupplier = false;
        const saved = response && response.data && response.data.data;
        if (saved && this.supplier.object && this.supplier.object.id === saved.id) {
          this.supplier.object = saved;
        }
      })
      .catch(() => {
        this.isSavingSupplier = false;
      })

    return promise;
  }


  @action
  loadAnalytics = (params) => {
    this.supplierAnalytics.isLoading = true;
    let promise = Api.get(`/suppliers/${params.uuid}/analytics`);

    promise
      .then((response) => {
        this.supplierAnalytics.isLoading = false;
        this.supplierAnalytics.isError = false;
        this.supplierAnalytics.objects = response.data;
      })
      .catch((error) => {
        this.supplierAnalytics.isLoading = false;
        this.supplierAnalytics.isError = true;
      })
    
    return promise;
  }

  // Leaving a supplier's page: forget them, so the next supplier opened
  // doesn't show this one while it loads.
  @action
  clearSelectedSupplier() {
    this.supplier = { isLoading: false, isError: false, object: blankSupplier() };
    this.supplierAnalytics = { isLoading: false, isError: false, objects: [] };
  }

  @action
  loadSupplier(params) {
    this.supplier.isLoading = true;
    let promise = Api.get(`/suppliers/${params.uuid}`)
    
    promise
      .then((response) => {
        this.supplier.isLoading = false;
        this.supplier.isError = false;
        this.supplier.object = response.data.data;
        stores.viewStore.supplierShow(params,response.data.data.attributes.name);
      })
      .catch((error) => {
        this.supplier.isLoading = false;
        this.supplier.isError = true;
        // 404/403: the supplier is gone or not ours; the page offers a way back.
        this.supplier.errorStatus = error && error.response ? error.response.status : null;
        console.error(error)
      })

    return promise;
  }

  
};

export default SupplierStore;